import { Button } from "antd";
import { formatDate, CurrencyFormat } from "../../../../../components/helpers";

export const convertCashTransaction = (cashTransactions, handleOpenPreview) => {
  let convertedCashTransaction = [];

  if (!cashTransactions) return [];

  console.log(cashTransactions);
  cashTransactions.forEach((transaction, index) => {
    convertedCashTransaction.push({
      key: index + 1,
      dateTime: formatDate(transaction.date_time) || "-",
      outletName: transaction.outlet_name || "-",
      officerName: transaction.office_name || "-",
      transactionType: transaction.transaction_type || "-",
      amount: `Rp ${CurrencyFormat(transaction.amount) || 0}`,
      description: transaction.description || "-",
      transactionProof: transaction.transaction_proof ? (
        <Button
          onClick={handleOpenPreview(
            `transaction/${transaction.transaction_id}/transaction-proof-picture`
          )}
          type="link"
        >
          Lihat File
        </Button>
      ) : (
        "-"
      ),
    });
  });
  return convertedCashTransaction;
};
